import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5743ecc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Changelog", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", { open: "" }, [
  /*#__PURE__*/_createElementVNode("summary", null, [
    /*#__PURE__*/_createTextVNode("v0.0.3 New Features! - "),
    /*#__PURE__*/_createElementVNode("time", null, "2022-05-04")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", { class: "balancing" }, "Balanced up to 28 factors."),
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, "Added Factor Calculator, a new feature!"),
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, "Added more upgrade, milestone and challenge.")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", { open: "" }, [
  /*#__PURE__*/_createElementVNode("summary", null, [
    /*#__PURE__*/_createTextVNode("v0.0.2 More things! - "),
    /*#__PURE__*/_createElementVNode("time", null, "2022-05-02")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", { class: "balancing" }, "Balanced up to 13 factors."),
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, " Added Factor Challenge as well as more upgrades and milestones. "),
    /*#__PURE__*/_createElementVNode("li", { class: "fix" }, "Make point gain format better.")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", { open: "" }, [
  /*#__PURE__*/_createElementVNode("summary", null, [
    /*#__PURE__*/_createTextVNode("v0.0.1.1 - "),
    /*#__PURE__*/_createElementVNode("time", null, "2022-05-02")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", { class: "fix" }, "Fixed some grammar problem.")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", { open: "" }, [
  /*#__PURE__*/_createElementVNode("summary", null, [
    /*#__PURE__*/_createTextVNode("v0.0.1 Rewrite Start! - "),
    /*#__PURE__*/_createElementVNode("time", null, "2022-05-02")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, " Added Number and Factor layer, including upgrades and milestones! ")
  ])
], -1))

import Modal from "components/Modal.vue";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const isOpen = ref(false);

expose({
    open() {
        isOpen.value = true;
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})